import React from "react";
import { useLocation } from "react-router";
import { AuthenticationConfig, AuthenticationType, buildAuthenticationConfigDefaults } from "sensei-authentication";
import {
  AuthenticationProvider,
  AuthenticatedUser,
  UnAuthenticatedUser,
  LoginProvider,
} from "sensei-authentication/components";
import useAppConfig from "../shared/useAppConfig";
import { useInject } from "../../di";
import { iid_authRootStore } from "../../services/authService/AuthRootStore";
import senseiLogo from "../../assets/images/Sensei_Logo.svg";
import { Copyright } from "../auth/Copyright";
import authStyles from "../auth/auth.module.scss";
import LoginBusyIndicator from "../auth/LoginBusyIndicator";
import SuccessfulAuth from "../auth/SuccessfulAuth";
import AppVersionFooter from "../auth/AppVersionFooter";
import AppRoutes from "./AppRoutes";

const employeeEmailDomain = "@csdental.com";

const authTypeSelection = (username: string): AuthenticationType =>
  username.toLowerCase().includes(employeeEmailDomain)
    ? AuthenticationType.employeeAD
    : AuthenticationType.customerAzureB2C;

const NoEULA: React.FC<{}> = () => null;

const AuthContainer: React.FC = () => {
  const config = useAppConfig();
  const authConfig: AuthenticationConfig = { allowEnterpriseRedirect: false, authentication: config!.authentication as any };
  buildAuthenticationConfigDefaults(authConfig);

  return (
    <AuthenticationProvider
      config={authConfig}
      rootStoreSymbol={iid_authRootStore}
      discoverService={useInject}
      authTypeSelection={authTypeSelection}
    >
      <UnAuthenticatedUser>
        <div className={authStyles.loginPageBackground}>
          <LoginProvider
            applicationName=""
            logo={senseiLogo}
            copyrightComponent={<Copyright />}
            AdBanner={<></>}
            BusyComponent={LoginBusyIndicator}
            SuccessfulAuth={SuccessfulAuth}
            EULAComponent={NoEULA}
            buttonColorClass={authStyles.signInButton}
            useRouteLocationHook={useLocation}
          />
          <AppVersionFooter appVersion={config!.buildVersion} env={config!.name} />
        </div>
      </UnAuthenticatedUser>
      <AuthenticatedUser>
        <AppRoutes />
      </AuthenticatedUser>
    </AuthenticationProvider>
  );
};

export default AuthContainer;
